<div class="flex justify-center">
    <p-menu #menu [model]="items" [popup]="true" appendTo="body">
        <ng-template #end>
            <div class="h-[35px] w-full bg-[#F7F1E9] flex items-center justify-center gap-2">
                @if (activityIcon) {
                    <p-tag styleClass="!bg-white rounded-lg h-[22px] !py-0">
                        <div
                            class="flex items-center gap-2 px-1 text-12 leading-[normal] font-light">
                            <fa-icon [icon]="activityIcon" /> <span class="ml-0.5">Desk</span>
                        </div>
                    </p-tag>
                }
                @if (quietMode) {
                    <p-tag styleClass="!bg-white rounded-lg h-[22px] !py-0">
                        <div
                            class="flex items-center gap-2 px-1 text-12 leading-[normal] font-light">
                            <fa-icon [icon]="faMicrophoneSlash" /> <span class="ml-0.5">Quiet</span>
                        </div>
                    </p-tag>
                }
            </div>
        </ng-template>
    </p-menu>
    <p-button
        size="large"
        icon="pi pi-ellipsis-v"
        [rounded]="true"
        [text]="true"
        severity="secondary"
        styleClass="!w-6 !h-10 !p-0"
        (click)="menu.toggle($event)" />
</div>
